import { EInvoiceAddressSchemeType, EntityType } from '@components'

import { TFunction } from 'i18next'
import { z } from 'zod'

import { CustomerType } from '@features/contacts/enums/customerType'

import { MissingCustomerDetailsFormSchema } from '../types/missingCustomerDetailsFormSchema'

export const getCustomerFormValidationSchema = (t: TFunction): MissingCustomerDetailsFormSchema => {
  return z.object({
    address: z.object({
      city: z
        .string()
        .trim()
        .nonempty({
          message: t(
            'external_invoices.missing_customer_compliance_details.modal.form.field.address.city.error.required',
          ),
        }),
      country: z.string(),
      pobox: z
        .string()
        .trim()
        .nonempty({
          message: t(
            'external_invoices.missing_customer_compliance_details.modal.form.field.address.pobox.error.required',
          ),
        }),
      streetAddress1: z.string().optional(),
      streetAddress2: z.string().optional(),
    }),
    companyName: z.string(),
    customerType: z.nativeEnum(CustomerType),
    eInvoiceAddress: z.object({
      address: z
        .string()
        .trim()
        .transform((address) => address.replace(/\s/g, ''))
        .optional(),
      scheme: z.nativeEnum(EInvoiceAddressSchemeType).optional(),
    }),
    entityType: z.nativeEnum(EntityType).optional(),
    id: z.string(),
  })
}
